import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


$(document).foundation();

$(document).ready(function(){

    $('#portals ul a').each(function() {
        $(this).attr('tabindex', -1);
    });

    new Foundation.Toggler($('#portals'), { toggler: 'expanded' });

    $('a.portals__toggle').click(function(e){
        e.preventDefault();
        $('#portals').foundation('toggle');

        $('#portals ul a').each(function() {
            if ($(this).attr('tabindex') == -1 || !$(this).attr('tabindex')) {
                $(this).attr('tabindex', 0);
            } else {
                $(this).attr('tabindex', -1);
            }
        });
    });

    // Site-wide Smooth Scroll
    $('a[href*="\\#"]').click(function(e){
        if (e.target.hash.length > 1) {
            let dest = $(e.target).attr('href');

            $('html,body').animate({
                scrollTop: $(dest).offset().top
            });
        }
    });
});